module.exports = __webpack_public_path__ + "img/ZB53详情页_02.9975d716.jpg";